import { IFormatterProps } from '../../../@types/workspaceTypes';
import { useId } from '@fluentui/react-hooks';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { BasicHeader } from '../../../actions/BasicHeader';
import { DirectionalHint } from '@fluentui/react';
import BooleanFormatter from './BooleanFormatter';
import React from 'react';
import { IAttachment } from '../../../graphql/schema/p4types';

const AttachmentsFormatter = (formatterProps: IFormatterProps<{ attachments: Array<IAttachment> }>) => {
  const tooltipId = useId(`attachments${formatterProps.rowIdx}`);
  const attachments = formatterProps.dependentValues.rowData?.attachments;
  if (attachments && attachments.length > 0) {
    return (
      <TooltipHost
        content={
          <>
            <BasicHeader>Attachments - File Names</BasicHeader>
            <div style={{ whiteSpace: 'pre-line', padding: '1em' }}>
              {attachments.map((attachment) => {
                if (!attachment) return '';
                if (attachment.type === 'PROOF_OF_DELIVERY') {
                  return `${attachment.fileName} [Proof of Delivery] \r\n`;
                }
                return `${attachment.fileName} \r\n`;
              })}
            </div>
          </>
        }
        // This id is used on the tooltip itself, not the host
        // (so an element with this id only exists when the tooltip is shown)
        id={tooltipId}
        directionalHint={DirectionalHint.leftCenter}
        calloutProps={{ styles: { root: { padding: 0 } } }}
      >
        <BooleanFormatter {...formatterProps} value={true} />
      </TooltipHost>
    );
  }
  return <BooleanFormatter {...formatterProps} value={false} />;
};

export default AttachmentsFormatter;
